import { fmtTs } from '../../utils/time';
import React from 'react';
import { useQuery } from 'react-query';
import { api } from '../../services/api';

const Tile = ({ label, value, sub, hot }: { label: string; value: string | number; sub?: string; hot?: boolean }) => (
  <div className={`rounded-2xl p-4 border ${hot ? 'border-brand-500/60 bg-brand-500/10' : 'border-white/10 bg-white/5'}`}>
    <p className="text-[11px] uppercase tracking-wider text-gray-500 font-bold">{label}</p>
    <p className="text-3xl font-black mt-1">{value}</p>
    {sub && <p className="text-xs text-gray-500 mt-0.5">{sub}</p>}
  </div>
);
const OUTCOME: Record<string, string> = { not_home: 'Not home', not_interested: 'No', interested: 'Interested', callback: 'Come back', signed: 'Signed 🎉' };

export default function SalesStats() {
  const { data } = useQuery('sales-stats', () => api.get('/sales/stats').then(r => r.data), { refetchInterval: 60000 });
  const { data: log } = useQuery('sales-visits', () => api.get('/sales/visits', { params: { days: 14 } }).then(r => r.data.visits as any[]));
  const conv = (s: any) => (s && s.doors ? `${Math.round(((s.interested + s.signed) / s.doors) * 100)}% warm` : '—');
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight">Scoreboard</h1>
        <p className="text-sm text-gray-500">Doors knocked, conversations started, yards signed.</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Tile label="Today" value={data?.today?.doors ?? 0} sub={`${data?.today?.interested ?? 0} interested · ${data?.today?.signed ?? 0} signed`} hot />
        <Tile label="This week" value={data?.week?.doors ?? 0} sub={conv(data?.week)} />
        <Tile label="30 days" value={data?.month?.doors ?? 0} sub={`${data?.month?.signed ?? 0} signed`} />
        <Tile label="Days out (14d)" value={data?.active_days_14 ?? 0} sub="days with at least one door" />
      </div>
      <div className="rounded-2xl border border-white/10 overflow-hidden">
        <div className="px-4 py-2.5 text-xs font-black uppercase tracking-wider text-gray-600 bg-white/5">Last 14 days</div>
        {(log || []).length === 0 ? <p className="p-4 text-sm text-gray-500">No doors logged yet. Build a plan and start knocking.</p> : (
          <ul className="divide-y divide-white/5">
            {(log || []).map((v: any) => (
              <li key={v.id} className="px-4 py-2.5 flex items-center gap-3">
                <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${v.outcome === 'signed' ? 'bg-brand-500 text-white' : v.outcome === 'interested' || v.outcome === 'callback' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-white/10 text-gray-300'}`}>{OUTCOME[v.outcome] || v.outcome}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm truncate">{v.address}{v.city ? `, ${v.city}` : ''}</p>
                  <p className="text-xs text-gray-500">{fmtTs(v.created_at, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}{v.contact_name ? ` · ${v.contact_name}` : ''}{v.notes ? ` · ${v.notes}` : ''}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
